var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.707 17.707L15 8.414L10.586 4L1.293 13.293C1.16506 13.4211 1.07418 13.5814 1.03 13.757L0 19L5.242 17.97C5.418 17.926 5.579 17.835 5.707 17.707ZM18 5.414C18.3749 5.03895 18.5856 4.53033 18.5856 4C18.5856 3.46967 18.3749 2.96106 18 2.586L16.414 1C16.0389 0.62506 15.5303 0.414429 15 0.414429C14.4697 0.414429 13.9611 0.62506 13.586 1L12 2.586L16.414 7L18 5.414Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.bcd33775e342a73afd2e79b0f4d590f0.svg";